import React from "react";
import {t} from "i18next";
import {getApartados, getDigitalContentBlockToShow} from "../Pages/ExerciseBlocks";

const ActivityTestRubrics = ({ rubrics, results, mode, refreshRubrics = null }) => {
    return (
        <div>
            {rubrics.map((rubric, index) => {
                const { alias, linkedFrom } = rubric.evaluationItem?.competence;
                let competence_id = rubric.evaluationItem?.competence?.sys.id;
                let result =
                    results?.competencies?.filter(
                        (c) => c.competency === competence_id
                    )[0];
                return (
                    <div className={`rubric ${mode} ${competence_id}`} key={`rubric${index}`}>
                        <div className="competenceTopBar">
                            {alias && linkedFrom ? (
                                <div className="competenceTitle">
                                    {t("competencia")} {alias} - {t("eje")}{" "}
                                    {linkedFrom.dimensionsCollection?.items[0]?.name}
                                </div>
                            ) : (
                                <div className="competenceTitle">
                                    {t("competencia")} {""} - {t("eje")}
                                    {""}
                                </div>
                            )}
                            {(mode === "display_with_data" || mode === "reviewed" || mode.includes("in_review")) && result ? (
                                <div className={`competenceScore ${ result.level > 1 ? "green" : "" }`}>
                                    {`N${result.level}` ?? "-"}
                                </div>
                            ) : null}
                        </div>

                        <div className="competenceItem">
                            {rubric.evaluationItem?.competence?.name}
                        </div>

                        <div className="evaluationItem">
                            <div className="title">{t("criterio.evaluacion")}</div>
                            <div className="text">
                                {rubric.evaluationItem?.evaluationItemText}
                            </div>
                        </div>

                        <div className="rubricTitle">{t("rubrica.evaluacion")}</div>

                        <div className="rubricItems">
                            {[
                                "level1Description",
                                "level2Description",
                                "level3Description",
                                "level4Description",
                            ].map((levelDescription, levelPosition) => {
                                return (
                                    <div
                                        className={`rubricItem n${levelPosition + 1} ${
                                            result?.level == `${levelPosition + 1}`
                                                ? "selected"
                                                : ""
                                        }`}
                                        key={`${rubric.sys.id}-${levelDescription}`}
                                    >
                                        <div className="title">N{levelPosition + 1}</div>
                                        <div className="text">
                                            {getApartados(rubric[levelDescription]?.json).map(
                                                (apartado, index) => {
                                                    return (
                                                        <div
                                                            key={`${rubric.sys.id}-${levelDescription}-${index}`}
                                                        >
                                                            {apartado.map((contentBlock, indexb) => {
                                                                return (
                                                                    <div
                                                                        className="contentBlock"
                                                                        key={`${rubric.sys.id}-${levelDescription}-${index}-${indexb}`}
                                                                    >
                                                                        {getDigitalContentBlockToShow(
                                                                            contentBlock,
                                                                            `${rubric.sys.id}-${levelDescription}-${index}-${indexb}`,
                                                                            null
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                        { refreshRubrics == null ?
                                            <svg
                                                className={`icon`}
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M14.8008 1.91091L14.9117 2.13116L15.7409 4.338C15.8057 4.51074 15.9424 4.64894 16.1166 4.71372L18.2471 5.51411C19.1828 5.86392 19.6852 6.86297 19.4362 7.80875L19.3757 7.9959L18.3853 10.1883C18.3472 10.2719 18.3275 10.3628 18.3275 10.4546C18.3275 10.5465 18.3472 10.6374 18.3853 10.721L19.3268 12.7939C19.5238 13.2284 19.5527 13.7205 19.4081 14.1752C19.2635 14.6298 18.9555 15.0147 18.5437 15.2556L18.3234 15.3664L16.1166 16.1956C16.0311 16.228 15.9535 16.2783 15.8889 16.3431C15.8244 16.4079 15.7744 16.4857 15.7423 16.5713L14.9419 18.7018C14.7743 19.1491 14.4468 19.5184 14.0226 19.738C13.5984 19.9577 13.1079 20.0122 12.6458 19.8909L12.4587 19.8304L10.2663 18.84C10.1826 18.8019 10.0918 18.7822 9.99994 18.7822C9.90805 18.7822 9.81723 18.8019 9.73362 18.84L7.66211 19.7815C7.22759 19.9785 6.73549 20.0075 6.28085 19.8628C5.82622 19.7182 5.44131 19.4102 5.20048 18.9984L5.08963 18.7781L4.25901 16.5713C4.22657 16.4858 4.17629 16.4082 4.1115 16.3437C4.04671 16.2791 3.96891 16.2291 3.88329 16.197L1.75275 15.3966C1.30544 15.2291 0.936219 14.9015 0.716558 14.4773C0.496896 14.0531 0.442422 13.5626 0.563682 13.1005L0.624143 12.9134L1.61599 10.721C1.65402 10.6373 1.67369 10.5465 1.67369 10.4546C1.67369 10.3628 1.65402 10.272 1.61599 10.1883L0.673088 8.11682C0.475982 7.68247 0.44679 7.19049 0.59115 6.73588C0.73551 6.28126 1.04318 5.89625 1.45476 5.65519L1.67502 5.54434L3.88329 4.71228C3.96906 4.68002 4.04694 4.62981 4.11174 4.56501C4.17654 4.50021 4.22675 4.42233 4.25901 4.33656L5.0594 2.20602C5.22696 1.75902 5.55431 1.39003 5.97815 1.1704C6.402 0.950765 6.89223 0.896092 7.35404 1.01695L7.54119 1.07741L9.73362 2.06926C9.81726 2.10729 9.90807 2.12696 9.99994 2.12696C10.0918 2.12696 10.1826 2.10729 10.2663 2.06926L12.3392 1.1278C12.7736 0.930691 13.2655 0.9015 13.7202 1.04586C14.1748 1.19022 14.5598 1.49789 14.8008 1.90947V1.91091ZM13.1166 7.15232L8.52872 12.3923L6.85596 10.7195C6.73443 10.6032 6.57219 10.5392 6.404 10.541C6.2358 10.5429 6.07502 10.6105 5.95608 10.7294C5.83714 10.8484 5.7695 11.0092 5.76765 11.1774C5.76579 11.3456 5.82987 11.5078 5.94616 11.6293L8.10549 13.7886C8.16781 13.8508 8.24222 13.8995 8.32412 13.9318C8.40602 13.9641 8.49367 13.9792 8.58165 13.9762C8.66962 13.9732 8.75605 13.9522 8.83559 13.9145C8.91513 13.8768 8.98609 13.8232 9.04408 13.757L14.0825 7.99878C14.1851 7.86927 14.2339 7.70526 14.2189 7.54073C14.2039 7.37619 14.1262 7.22374 14.0018 7.11494C13.8775 7.00614 13.7161 6.94934 13.551 6.9563C13.3859 6.96326 13.2299 7.03344 13.1151 7.15232H13.1166Z"
                                                    fill="#374047"
                                                />
                                            </svg>
                                            :
                                            <input
                                                className={`radio`}
                                                type="radio"
                                                id={`radioButton${levelPosition}`}
                                                name={`radioGroup${rubric.sys.id}`}
                                                onChange={refreshRubrics}
                                                checked={
                                                    result.level ===
                                                    levelPosition + 1
                                                }
                                            />
                                        }

                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ActivityTestRubrics;
